/**
 * Strip common automation prefixes from an Outlook calendar subject
 * before using it as a meeting title.
 *
 * Examples:
 *   "Updated: Duke Park Review"      -> "Duke Park Review"
 *   "[Teams] Monthly Sync"           -> "Monthly Sync"
 *   "FW: Client Meeting"             -> "Client Meeting"
 *   "Canceled: Duke Park Review"     -> "Duke Park Review"
 *
 * Prefixes are stripped iteratively so chains like "FW: Updated: ..."
 * collapse correctly. If stripping would leave an empty string (e.g.
 * the whole subject was a prefix), we fall back to the original so
 * the user at least sees something in the title field.
 */
const PREFIX_PATTERNS: RegExp[] = [
  /^\s*updated\s*:\s*/i,
  /^\s*canceled\s*:\s*/i,
  /^\s*cancelled\s*:\s*/i,
  /^\s*\[teams\]\s*/i,
  /^\s*\[zoom\]\s*/i,
  /^\s*fw\s*:\s*/i,
  /^\s*fwd\s*:\s*/i,
  /^\s*re\s*:\s*/i,
  /^\s*accepted\s*:\s*/i,
  /^\s*declined\s*:\s*/i,
  /^\s*tentatively accepted\s*:\s*/i,
];

export function cleanCalendarSubject(subject: string): string {
  if (!subject) return '';
  let cleaned = subject;
  // Loop until no pattern matches anymore — handles stacked prefixes
  // like "FW: Updated: ..." which are common after forwards.
  let changed = true;
  let safety = 8;
  while (changed && safety-- > 0) {
    changed = false;
    for (const re of PREFIX_PATTERNS) {
      const next = cleaned.replace(re, '');
      if (next !== cleaned) {
        cleaned = next;
        changed = true;
      }
    }
  }
  const trimmed = cleaned.trim();
  return trimmed.length > 0 ? trimmed : subject.trim();
}
